module.exports = __webpack_public_path__ + "img/OAN.6b57b343.png";